import React, { useEffect, useState, useRef } from "react";
import { applyActionCode, verifyPasswordResetCode, confirmPasswordReset } from "firebase/auth";
import { auth } from "../firebase";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function VerifyAccount() {
  const [status, setStatus] = useState("verificando");
  const [message, setMessage] = useState("");
  const { currentUser, refreshUser } = useAuth();
  const navigate = useNavigate();
  const ranOnce = useRef(false);
  const [newPassword, setNewPassword] = useState("");
  const [resetOobCode, setResetOobCode] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
const [isSubmitted, setIsSubmitted] = useState(false);


  const isMobile =
    window.matchMedia("(pointer: coarse)").matches ||
    /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    navigator.userAgentData?.mobile ||
    window.innerWidth < 768;


  const baseURL = process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_DEV_URL
    : 'https://revisaja-0b95e6e3ff11.herokuapp.com';


  const getSuccessMessage = () => {
    if (!isMobile) {
      // 💻 Usuário no desktop
      return "Verificação concluída! Agora você pode continuar sua revisão.";
    }

    if (isMobile && currentUser) {
      // 📱 Usuário no celular e logado
      return "Verificação concluída! Agora você pode continuar sua revisão.";
    }

    // 📱 Usuário no celular e deslogado
    return "Verificação concluída! Se você estava no computador, faça o login pelo celular para continuar sua revisão ou volte para o outro dispositivo.";

  };


  const validatePasswordStrength = (password) => {
    const minLength = password.length >= 8;
    const hasUpper = /[A-Z]/.test(password);
    const hasLower = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecial = /[^A-Za-z0-9]/.test(password);

    return {
      minLength,
      hasUpper,
      hasLower,
      hasNumber,
      hasSpecial,
      isValid: minLength && hasUpper && hasLower && hasNumber && hasSpecial,
    };
  };


  const handleSaveNewPassword = () => {
  setIsSubmitted(true);

  const strength = validatePasswordStrength(newPassword);
  const newErrors = {};

  if (!strength.isValid) {
    newErrors.password = "Senha fraca";
  }

  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    return; // ❌ impede o envio se houver erro
  }

  // ✔ senha válida → prossegue
  resetPasswordFlow(resetOobCode, newPassword);
};



  const resetPasswordFlow = async (oobCode, newPassword) => {
    try {
      await verifyPasswordResetCode(auth, oobCode);
      await confirmPasswordReset(auth, oobCode, newPassword);

      setStatus("senhaResetada");
      setMessage("Senha redefinida com sucesso! Agora você pode fazer login.");

    } catch (error) {
      console.error("Erro ao redefinir senha:", error);
      setStatus("erro");
      setMessage("Este link não é válido ou já expirou.");
    }
  };



  const verifyToken = async (token) => {
    try {
      const response = await fetch(`${baseURL}/auth/verify-custom?token=${token}`);
      const data = await response.json();

      if (data.success) {
        setStatus("sucesso");
        setMessage(getSuccessMessage());
      } else {
        setStatus("erro");
        setMessage(data.message || "Token inválido ou expirado.");
      }
    } catch {
      setStatus("erro");
      setMessage("Erro ao verificar token customizado.");
    }
  };



  const verifyAccount = async (mode, oobCode) => {
    if (mode !== "verifyEmail" || !oobCode) {
      setStatus("erro");
      setMessage("Link inválido ou expirado.");
      return;
    }

    try {
      await applyActionCode(auth, oobCode);
      await refreshUser?.();
      setStatus("sucesso");
      setMessage(getSuccessMessage());
    } catch (error) {
      console.error("Erro ao verificar e-mail:", error);
      setStatus("erro");
      setMessage("Não foi possível verificar o e-mail. O link pode ter expirado.");
    }
  };



  const handleNavigate = async () => {
    localStorage.setItem('currentStep', '0');
    navigate('/revisao');
  }



  useEffect(() => {


    if (ranOnce.current) return;

    ranOnce.current = true;
    let isMounted = true;
    const params = new URLSearchParams(window.location.search);
    const mode = params.get("mode");
    const oobCode = params.get("oobCode");
    const token = params.get("token");

    if (token) {
      verifyToken(token);
    }
    else if (mode === "resetPassword" && oobCode) {
  (async () => {
    try {
      await verifyPasswordResetCode(auth, oobCode);  // <-- valida aqui
      setResetOobCode(oobCode);
      setStatus("resetPassword"); // <-- só mostra o input se for válido
    } catch (error) {
      setStatus("erro");
      setMessage("Este link não é válido ou já expirou.");
    }
  })();
    }
    else {
      verifyAccount(mode, oobCode);
    }

    return () => {
      isMounted = false;
    };

  }, [refreshUser, navigate]);




  return (
    <div className="large-top-margin verify-account">
      {status === "verificando" && (
        <>
          <h2>Verificando seu e-mail...</h2>
          <p>Aguarde alguns instantes.</p>
        </>
      )}

      {status === "sucesso" && (
        <div>
          <h2>✅ E-mail verificado com sucesso!</h2>
          <p>{message}</p>
          {currentUser ? (
            <button className="medium-top-margin" onClick={handleNavigate}>Continuar revisão</button>
          ) : (
            <button className="medium-top-margin" onClick={() => navigate("/")}>Voltar ao início</button>
          )}
        </div>
      )}


      {status === "resetPassword" && (
        <div>
          <h2>Redefinir senha</h2>
          <p>Digite a nova senha abaixo.</p>

          <div className="reset-passord">
            <div className="input-container">
              <label>SENHA</label>
              <div className='password-container row login'>
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  placeholder="Senha"
                  onChange={(e) => setNewPassword(e.target.value)}
                  className={errors.password ? "error" : ""}
                  autoComplete="new-password"
                />
                <span className='eye-icon' onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? (<img className="eyeSlash" src="/assets/eyeSlash.svg" alt="Ícone de olho fechado" />) : (<img className="eye" src="/assets/eye.svg" alt="Ícone de olho aberto" />)}
                </span>
              </div>


              {newPassword && (
                <ul className="password-checklist">
                  <li className={validatePasswordStrength(newPassword).hasLower ? "valid" : "invalid"}>
                    <span className="icon">
                      {validatePasswordStrength(newPassword).hasLower ? "✔" : "✖"}
                    </span>
                    Letra minúscula
                  </li>
                  <li className={validatePasswordStrength(newPassword).hasUpper ? "valid" : "invalid"}>
                    <span className="icon">
                      {validatePasswordStrength(newPassword).hasUpper ? "✔" : "✖"}
                    </span>
                    Letra maiúscula
                  </li>
                  <li className={validatePasswordStrength(newPassword).hasNumber ? "valid" : "invalid"}>
                    <span className="icon">
                      {validatePasswordStrength(newPassword).hasNumber ? "✔" : "✖"}
                    </span>
                    Número
                  </li>
                  <li className={validatePasswordStrength(newPassword).hasSpecial ? "valid" : "invalid"}>
                    <span className="icon">
                      {validatePasswordStrength(newPassword).hasSpecial ? "✔" : "✖"}
                    </span>
                    Caractere especial
                  </li>
                  <li className={validatePasswordStrength(newPassword).minLength ? "valid" : "invalid"}>
                    <span className="icon">
                      {validatePasswordStrength(newPassword).minLength ? "✔" : "✖"}
                    </span>
                    Mínimo 8 caracteres
                  </li>
                </ul>
              )}

            </div>


            <button onClick={handleSaveNewPassword}>
              Salvar nova senha
            </button>

          </div>

        </div>
      )}


      {status === "senhaResetada" && (
        <div>
          <h2>✅ Senha redefinida!</h2>
          <p>{message}</p>

          <button
            className="medium-top-margin"
            onClick={() => navigate("/login")}
          >
            Voltar ao login
          </button>
        </div>
      )}


      {status === "erro" && (
        <div>
          <h2>❌ Erro na verificação</h2>
          <p>{message}</p>
          <button className="medium-top-margin" onClick={() => navigate("/")}>
            Voltar ao início
          </button>
        </div>
      )}
    </div>
  );
}
